import { useContext } from 'react';
import { ILanguageContext, LanguageContext } from '~/App';
import LocalizedStrings, { LanguageEnum } from '~/constants/localizedString';
import LocalizedTrademarksStrings from '~/constants/localizedString/trademarks';
import LocalizedFileStrings from '~/constants/localizedString/file';

export const LanguageLocalStorageIdentifier = '_mqfl_la';

export const useLanguage = () => {
  const { language, ...restContext } = useContext<ILanguageContext>(LanguageContext);

  const setLanguage = (language: LanguageEnum) => {
    restContext.setLanguage(language);
  };

  return {
    Lang: {
      ...LocalizedStrings[language],
      trademarks: LocalizedTrademarksStrings[language],
      file: LocalizedFileStrings[language],
    },
    language,
    setLanguage,
  };
};
